import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAuthService } from './modules/auth/services/user.service';
import { MaintenanceSignalRService } from './modules/maintenance/services/maintenance-signalR.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public isAuthLoading$: Observable<boolean>;
    constructor(
        private userAuthService: UserAuthService,
        private maintenanceSignalRService: MaintenanceSignalRService
    ) {}

    ngOnInit() {
        this.isAuthLoading$ = this.userAuthService.loadingAuth$;
        this.maintenanceSignalRService.startConnection();
    }
}
